import React, { useState } from 'react';
import styles from './FAQComponent.module.css';

const faqs = [
  {
    question: 'Can I connect my existing CRM?',
    answer: 'Yes, Toxbox integrates seamlessly with major CRMs like Salesforce, HubSpot, Zoho, and more.',
  },
  {
    question: 'How fast can I set up Toxbox AI?',
    answer: 'Setup takes less than 10 minutes — connect your number, configure basic settings, and your AI agent is ready.',
  },
  {
    question: 'Is my data secure?',
    answer: 'Absolutely. All calls and CRM data are encrypted, GDPR-ready, and stored on secure servers.',
  },
  {
    question: 'Does Toxbox support multiple languages?',
    answer: 'Yes, our AI can converse in multiple languages to support your global customers.',
  },
  {
    question: 'Can Toxbox handle high call volumes?',
    answer: 'Yes, it scales automatically. Handle thousands of calls simultaneously without hiring additional staff.',
  },
  {
    question: 'How does the AI qualify leads?',
    answer: 'Toxbox asks predefined questions, captures contact details, evaluates intent, and prioritizes leads automatically in the CRM.',
  },
  {
    question: 'Can I customize the AI conversation?',
    answer: 'Yes, you can edit scripts, set responses, and tailor the flow for your business needs.',
  },
  {
    question: 'Will my team get notifications for important leads?',
    answer: 'Yes, you can set automated email, SMS, or CRM notifications for high-priority leads.',
  },
  {
    question: 'Can I see analytics and reports?',
    answer: 'Yes, the dashboard shows call activity, lead conversion stats, response times, and team performance metrics in real time.',
  },
  {
    question: 'Does Toxbox integrate with other tools?',
    answer: 'Yes, it integrates with Slack, email clients, calendars, and many other SaaS tools to fit into your workflow.',
  },
  {
    question: 'What happens if a call requires a human?',
    answer: 'Toxbox can automatically route calls to the right team member or department based on your rules.',
  },
  {
    question: 'Can I try Toxbox before committing?',
    answer: 'Yes, we offer a free trial to test AI calls + CRM functionality before you upgrade.',
  },
  {
    question: 'Is Toxbox suitable for small businesses?',
    answer: 'Absolutely. Toxbox provides enterprise-grade automation without requiring a large team.',
  },
  {
    question: 'Does Toxbox comply with call recording laws?',
    answer: 'Yes, all recordings follow legal requirements and can be turned on/off per region.',
  },
  {
    question: 'Can I export my leads and call data?',
    answer: 'Yes, all CRM data can be exported in CSV, Excel, or integrated with your BI tools.',
  },
];

const FAQComponent = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const half = Math.ceil(faqs.length / 2);
  const leftColumn = faqs.slice(0, half);
  const rightColumn = faqs.slice(half);

  return (
    <section className={styles.faqSection}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            Frequently Asked <span className={styles.purpleText}>Questions</span>
          </h2>
          <p className={styles.subtitle}>Everything You Need to Know About ToxBox’s AI</p>
        </div>

        <div className={styles.grid}>
          <div className={styles.column}>
            {leftColumn.map((faq, index) => (
              <div
                key={index}
                className={`${styles.faqItem} ${openIndex === index ? styles.active : ''}`}
                onClick={() => toggleFAQ(index)}
              >
                <div className={styles.question}>
                  <span>{faq.question}</span>
                  <span className={styles.icon}>{openIndex === index ? '−' : '+'}</span>
                </div>
                {openIndex === index && (
                  <div className={styles.answer}>
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className={styles.column}>
            {rightColumn.map((faq, index) => {
              const globalIndex = index + half;
              return (
                <div
                  key={globalIndex}
                  className={`${styles.faqItem} ${openIndex === globalIndex ? styles.active : ''}`}
                  onClick={() => toggleFAQ(globalIndex)}
                >
                  <div className={styles.question}>
                    <span>{faq.question}</span>
                    <span className={styles.icon}>{openIndex === globalIndex ? '−' : '+'}</span>
                  </div>
                  {openIndex === globalIndex && (
                    <div className={styles.answer}>
                      <p>{faq.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQComponent;
